/* ============================================================
   MUMS SEARCH — dedicated controller + live predictive search (P1+P2, hardened P4).
   Owns the header-search input entirely (the theme's <predictive-search> wrapper was
   removed in the markup, so no parallel fetch / ARIA fight). Drives Shopify's
   /search/suggest.json — one blended panel: Collections → Products → Related, live as
   you type. Proper combobox/listbox a11y, focus management, loading + no-results states.
   ============================================================ */
(function () {

  /* Locale-aware storefront URLs.
   *
   * Shopify serves an additional locale from a subfolder — Shopify.routes.root is '/th/' on the
   * Thai storefront and '/' on the primary one. Every endpoint below used to be root-relative,
   * so on /th they hit the ENGLISH storefront and returned English titles and option names: the
   * cart drawer, quick view, predictive search, Pairs Well With and the bestsellers rail all
   * silently ignored the locale. Translating products would have appeared to do nothing.
   */
  function mumsUrl(path) {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    if (root.charAt(root.length - 1) !== '/') root += '/';
    return root + String(path).replace(/^\/+/, '');
  }
  /* DEV TOGGLE — ?mumsmobile=1 forces the mobile (<=749/760px) layout on at ANY window width,
     so mobile styling can be reviewed on desktop without a phone. It clones every mobile
     @media rule from the loaded stylesheets and re-applies them unconditionally, so it stays
     in sync with the CSS automatically. Off by default; no effect without the query param. */
  (function mumsMobilePreview() {
    try {
      if (!/[?&]mumsmobile=1/.test(location.search)) return;
      function apply() {
        if (document.getElementById('mums-mobile-preview')) return;
        document.documentElement.classList.add('mums-mobile-preview');
        var css = '';
        [].forEach.call(document.styleSheets, function (ss) {
          var rules; try { rules = ss.cssRules; } catch (e) { return; }
          if (!rules) return;
          [].forEach.call(rules, function (r) {
            if (r.type === CSSRule.MEDIA_RULE && /max-width:\s*(749|760)px/.test(r.media.mediaText)) {
              [].forEach.call(r.cssRules, function (inner) { css += inner.cssText + '\n'; });
            }
          });
        });
        var st = document.createElement('style'); st.id = 'mums-mobile-preview'; st.textContent = css;
        document.head.appendChild(st);
      }
      if (document.readyState === 'complete') apply();
      else window.addEventListener('load', apply);
    } catch (e) { /* dev aid only */ }
  })();

  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }

  // suggest.json price is a decimal string ("99.00") or cents ("9900") — always ฿-prefix, escaped
  function money(v) {
    if (v == null || v === '') return '';
    var s = String(v);
    if (/^\d+$/.test(s)) s = (parseInt(s, 10) / 100).toFixed(2);
    return '฿' + esc(s);
  }

  // shrink the CDN image to a real thumbnail (raw URL is full-res ~1300px)
  function thumb(u) { return u ? esc(u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=120') : ''; }

  // the product's shop category (from its type tag)
  var CATS = ['Sour', 'Sweet', 'Chocolate', 'Licorice', 'Salty'];
  function catOf(p) {
    var tags = (p && p.tags) || [];
    for (var i = 0; i < CATS.length; i++) if (tags.indexOf(CATS[i]) > -1) return CATS[i];
    return '';
  }
  // top dietary claim (Vegan > Vegetarian > Dairy-Free > Gluten-Free), matched from tags
  var DIET_MAP = [['Vegan', 'vegan'], ['Vegetarian', 'vegetarian'], ['Dairy-Free', 'dairyfree'], ['Gluten-Free', 'glutenfree']];
  function dietOf(p) {
    var tags = ((p && p.tags) || []).map(function (t) { return String(t).toLowerCase().replace(/[^a-z]/g, ''); });
    for (var i = 0; i < DIET_MAP.length; i++) if (tags.indexOf(DIET_MAP[i][1]) > -1) return DIET_MAP[i][0];
    return '';
  }
  // category + dietary as PLAIN TEXT, e.g. "Sour · Vegan" (was a coloured category pill)
  function metaOf(p) {
    var parts = []; var c = catOf(p), d = dietOf(p);
    if (c) parts.push(c); if (d) parts.push(d);
    return parts.join(' · ');
  }

  // recent searches (localStorage, most-recent first, deduped, capped)
  var RECENT_KEY = 'mums_recent_searches';
  function getRecents() { try { return JSON.parse(localStorage.getItem(RECENT_KEY)) || []; } catch (e) { return []; } }
  function saveRecent(q) {
    q = (q || '').trim(); if (q.length < 2) return;
    try {
      var list = getRecents().filter(function (x) { return x.toLowerCase() !== q.toLowerCase(); });
      list.unshift(q); localStorage.setItem(RECENT_KEY, JSON.stringify(list.slice(0, 6)));
    } catch (e) {}
  }
  function removeRecent(q) { try { localStorage.setItem(RECENT_KEY, JSON.stringify(getRecents().filter(function (x) { return x !== q; }))); } catch (e) {} }

  // wrap each typed term in <b> within an escaped title (blush highlight)
  function highlight(title, q) {
    var t = esc(title);
    (q.trim().split(/\s+/).filter(Boolean)).forEach(function (term) {
      var re = new RegExp('(' + term.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + ')', 'ig');
      t = t.replace(re, '<b>$1</b>');
    });
    return t;
  }

  function initHost(host) {
    if (!host || host._mumsWired) return;
    host._mumsWired = true;

    var toggle = host.querySelector('.header__icon--search');
    var overlay = host.querySelector('.header__search-overlay');
    var panel = host.querySelector('.header__search-inner');
    var input = host.querySelector('input[type="search"][name="q"]');
    var results = host.querySelector('[data-mums-results]');
    var empty = host.querySelector('[data-mums-empty]');
    var status = host.querySelector('.mums-s-status');
    var closeBtn = host.querySelector('[data-mums-close]');
    var recentSec = host.querySelector('[data-mums-recent-sec]');
    var recentBox = host.querySelector('[data-mums-recent]');
    if (!toggle || !input) return;

    var lastFocus = null;

    /* ---- open / close ---- */
    // Mobile: search is a full-screen takeover, so the theme's nav drawer must be
    // dismissed first — otherwise the panel layers on top of the open drawer + page.
    function closeNavDrawer() {
      var det = document.querySelector('header-drawer details[open], header details.menu-drawer-container[open]');
      if (det) {
        det.removeAttribute('open');
        var sum = det.querySelector('summary'); if (sum) sum.setAttribute('aria-expanded', 'false');
      }
      // the theme locks scroll with a body class while the drawer is open — clear ALL variants
      // (esp. overflow-hidden-drawer, which the hamburger uses; missing it left scroll locked
      // after searching from the menu and closing).
      document.body.classList.remove(
        'overflow-hidden-mobile', 'overflow-hidden-tablet', 'overflow-hidden',
        'overflow-hidden-drawer', 'overflow-hidden-cart-drawer', 'overflow-hidden-facets'
      );
    }
    function open() {
      lastFocus = document.activeElement;
      closeNavDrawer();
      renderRecents();
      host.setAttribute('open', '');
      document.body.classList.add('overflow-hidden-search');
      // focus SYNCHRONOUSLY inside the tap gesture — iOS only opens the keyboard if focus()
      // runs in the same user-gesture tick (a rAF defers past it). rAF stays as a fallback.
      try { input.focus({ preventScroll: true }); } catch (e) { try { input.focus(); } catch (e2) {} }
      requestAnimationFrame(function () { try { input.focus(); } catch (e) {} });
    }
    // recent-searches list (empty state) — function declaration is hoisted so open() can call it
    function renderRecents() {
      if (!recentSec || !recentBox) return;
      var list = getRecents();
      if (!list.length) { recentSec.hidden = true; recentBox.innerHTML = ''; return; }
      recentSec.hidden = false;
      recentBox.innerHTML = list.map(function (t) {
        return '<div class="mums-recent-row" data-term="' + esc(t) + '">' +
          '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg>' +
          '<span class="t">' + esc(t) + '</span>' +
          '<button type="button" class="x" data-remove aria-label="Remove"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button></div>';
      }).join('');
    }
    function close() {
      host.removeAttribute('open');
      document.body.classList.remove('overflow-hidden-search');
      input.value = '';
      if (empty && results) showEmpty();
      try { (lastFocus && lastFocus.focus) ? lastFocus.focus() : toggle.focus(); } catch (e) {}
    }
    host._mumsOpen = open;
    host._mumsClose = close;

    // OPEN only (never toggle) so we can't race the theme's own listener into closing
    toggle.addEventListener('click', function (e) { e.preventDefault(); open(); });
    if (overlay) overlay.addEventListener('click', close);
    if (closeBtn) closeBtn.addEventListener('click', close);
    // ESC + simple focus trap, scoped to this host while open
    host.addEventListener('keydown', function (e) {
      if (!host.hasAttribute('open')) return;
      if (e.key === 'Escape') { e.preventDefault(); close(); return; }
      if (e.key === 'Tab' && panel) {
        var f = panel.querySelectorAll('a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])');
        f = Array.prototype.filter.call(f, function (el) { return el.offsetParent !== null; });
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });

    // recent: click a term to re-run its search; ✕ to remove it
    if (recentBox) recentBox.addEventListener('click', function (e) {
      var row = e.target.closest('.mums-recent-row'); if (!row) return;
      var term = row.getAttribute('data-term');
      if (e.target.closest('[data-remove]')) { e.preventDefault(); removeRecent(term); renderRecents(); return; }
      input.value = term; input.focus(); input.dispatchEvent(new Event('input', { bubbles: true }));
    });
    // On submit (Enter / search button): go to /search with an explicit `*` prefix wildcard so the
    // full results page matches partial terms the same way predictive does (e.g. "vani" → Vanilla).
    // The theme's options[prefix]=last isn't honored reliably on the results page; the `*` is.
    var searchForm = host.querySelector('form.search__form');
    if (searchForm) searchForm.addEventListener('submit', function (e) {
      saveRecent(input.value);
      var term = (input.value || '').trim();
      if (term) { e.preventDefault(); window.location.href = mumsUrl('search?q=') + encodeURIComponent(term) + '*&type=product&options%5Bunavailable_products%5D=show'; }
    });

    if (!results || !empty) return; // live search needs these; open/close still work above

    // remember the query when a result is opened
    results.addEventListener('click', function (e) { if (e.target.closest('a[href]')) saveRecent(input.value); });

    /* ---- live search ---- */
    var ctrl = null, debounceT = null, activeIdx = -1;

    function setLoading(on) { if (panel) panel.classList.toggle('is-loading', !!on); }

    function showEmpty() {
      empty.hidden = false;
      results.hidden = true;
      results.innerHTML = '';
      activeIdx = -1;
      setLoading(false);
      input.setAttribute('aria-expanded', 'false');
      input.removeAttribute('aria-activedescendant');
    }

    function run(q) {
      if (ctrl) ctrl.abort();
      ctrl = new AbortController();
      setLoading(true);
      var url = mumsUrl('search/suggest.json?q=') + encodeURIComponent(q) +
        '&resources[type]=product,collection,query&resources[limit]=8' +
        // limit_scope=each → the limit applies PER type (else it's a shared total, capping products ~3)
        '&resources[limit_scope]=each' +
        // sold-out candy is findable and ranked by relevance, not pushed out of the 8 slots (2026-10-09: a search for
        // "bubblegum" hid Sour Bubblegum Skulls). Its card carries the notify-me bell.
        '&resources[options][unavailable_products]=show' +
        // search beyond name/flavour: also match product type, variant titles, vendor, TAGS (flavour/
        // dietary/category) and the description body
        '&resources[options][fields]=title,product_type,variants.title,vendor,tag,body';
      fetch(url, { signal: ctrl.signal })
        .then(function (r) { return r.json(); })
        .then(function (data) { if (input.value.trim() === q) render(data, q); })
        .catch(function (e) { if (e.name !== 'AbortError') { setLoading(false); showError(); } });
    }

    function showError() {
      results.innerHTML = '<div class="mums-s-noresult"><div class="mums-s-nr-h">Hmm</div><p>Search hiccuped. Try again in a sec.</p></div>';
      results.hidden = false; empty.hidden = true;
      if (seeall) seeall.hidden = true;
    }

    function curateQueries(queries, q) {
      var ql = q.toLowerCase(), seen = {}, out = [];
      queries.forEach(function (x) {
        var t = (x.text || '').trim(), k = t.toLowerCase();
        if (!t || k === ql || seen[k]) return;          // drop exact-match + dupes
        var words = k.split(/\s+/);
        if (words.length > 3) return;                    // drop long log-noise strings
        if (words.some(function (w) { return w.length <= 1; })) return; // drop orphan single-char tokens ("s ovals…")
        seen[k] = 1; out.push(x);
      });
      return out.slice(0, 3);
    }

    function render(data, q) {
      setLoading(false);
      var res = (data && data.resources && data.resources.results) || {};
      var cols = (res.collections || []).slice(0, 6);
      var prods = res.products || [];
      var queries = curateQueries(res.queries || [], q);
      var html = '', id = 0;

      if (cols.length) {
        html += '<div class="mums-s-sec"><div class="mums-s-sec-h">Collections</div><div class="mums-col-chips">';
        cols.forEach(function (c) {
          html += '<a class="mums-col-chip" id="ms-i-' + (id++) + '" role="option" aria-selected="false" href="' + esc(c.url) + '">' + esc(c.title) + '</a>';
        });
        html += '</div></div>';
      }
      if (prods.length) {
        html += '<div class="mums-s-sec"><div class="mums-s-sec-h">Products</div>';
        prods.forEach(function (p) {
          var img = p.image ? '<img src="' + thumb(p.image) + '" alt="" loading="lazy" width="46" height="46">' : '';
          html += '<a class="mums-p-row" id="ms-i-' + (id++) + '" role="option" aria-selected="false" href="' + esc(p.url) + '">' +
            '<div class="mums-p-thumb">' + img + '</div>' +
            '<div class="mums-p-info"><div class="mums-p-name">' + highlight(p.title, q) + '</div>' +
            (function () { var m = metaOf(p); return m ? '<div class="mums-p-meta">' + esc(m) + '</div>' : ''; })() + '</div>' +
            '<div class="mums-p-price">' + money(p.price) + '</div>' +
            '<span class="mums-p-add" aria-hidden="true">+</span></a>';
        });
        html += '</div>';
      }
      if (queries.length) {
        html += '<div class="mums-s-sec"><div class="mums-s-sec-h">Related Searches</div>';
        queries.forEach(function (qq) {
          html += '<a class="mums-term" id="ms-i-' + (id++) + '" role="option" aria-selected="false" href="' + mumsUrl('search?q=') + encodeURIComponent(qq.text) + '*&type=product&amp;options%5Bunavailable_products%5D=show">' +
            '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="m20 20-3.8-3.8"/></svg>' +
            '<span class="t">' + (qq.styled_text || esc(qq.text)) + '</span></a>';
        });
        html += '</div>';
      }
      if (prods.length) {
        html += '<a class="mums-s-all-row" id="ms-i-' + (id++) + '" role="option" aria-selected="false" href="' + mumsUrl('search?q=') + encodeURIComponent(q) + '*&type=product&amp;options%5Bunavailable_products%5D=show">See all results for “' + esc(q) + '” →</a>';
      }
      if (!html) {
        html = '<div class="mums-s-noresult"><div class="mums-s-nr-h">Nothing Here</div>' +
          '<p>No match for “' + esc(q) + '”. We do gummies, not chocolate — try sour, cola, raspberry or vegan.</p></div>';
      }

      results.innerHTML = html;
      results.hidden = false;
      empty.hidden = true;
      activeIdx = -1;
      input.setAttribute('aria-expanded', 'true');
      input.removeAttribute('aria-activedescendant');

      if (status) status.textContent = prods.length ? (prods.length + ' product results for ' + q) : ('No results for ' + q);
    }

    input.addEventListener('input', function () {
      var q = input.value.trim();
      clearTimeout(debounceT);
      if (q.length < 2) { showEmpty(); return; }
      debounceT = setTimeout(function () { run(q); }, 150);
    });

    /* ---- keyboard nav ---- */
    function itemList() { return Array.prototype.slice.call(results.querySelectorAll('a[href][role="option"]')); }
    function setActive(items) {
      items.forEach(function (el, i) {
        var on = i === activeIdx;
        el.classList.toggle('is-active', on);
        el.setAttribute('aria-selected', on ? 'true' : 'false');
        if (on) { input.setAttribute('aria-activedescendant', el.id); el.scrollIntoView({ block: 'nearest' }); }
      });
      if (activeIdx < 0) input.removeAttribute('aria-activedescendant');
    }
    input.addEventListener('keydown', function (e) {
      if (results.hidden) return; // let the native <form> submit to /search on Enter
      var items = itemList();
      if (e.key === 'ArrowDown') { e.preventDefault(); activeIdx = Math.min(activeIdx + 1, items.length - 1); setActive(items); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); activeIdx = Math.max(activeIdx - 1, -1); setActive(items); }
      else if (e.key === 'Enter') {
        if (activeIdx >= 0 && items[activeIdx]) { e.preventDefault(); items[activeIdx].click(); }
        // else: no active item → let the native form submit (avoids double navigation)
      }
    });
  }

  // The mobile nav-drawer's inline search field is the theme's "old" search. Turn it into a
  // trigger for our full-screen takeover: tap → close drawer + open the predictive panel.
  function wireDrawerSearch() {
    var host = document.querySelector('header-search');
    if (!host || !host._mumsOpen) return;
    var ds = document.querySelector('.menu-drawer__search');
    if (!ds || ds.dataset.mumsWired) return;
    ds.dataset.mumsWired = '1';
    var input = ds.querySelector('input');
    if (input) { input.setAttribute('readonly', 'readonly'); input.setAttribute('inputmode', 'none'); }
    ds.addEventListener('click', function (e) { e.preventDefault(); host._mumsOpen(); });
    if (input) input.addEventListener('focus', function () { host._mumsOpen(); });
  }
  function init() {
    var hosts = document.querySelectorAll('header-search');
    Array.prototype.forEach.call(hosts, initHost);
    try { wireDrawerSearch(); } catch (e) {}
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  // re-wire after Theme Editor / Section Rendering API swaps the header (per-element guard keeps it safe)
  document.addEventListener('shopify:section:load', init);
})();
